import { render, staticRenderFns } from "./addTaskPage.vue?vue&type=template&id=7c3f615d&scoped=true&"
import script from "./addTaskPage.vue?vue&type=script&lang=tsx&"
export * from "./addTaskPage.vue?vue&type=script&lang=tsx&"
import style0 from "./addTaskPage.vue?vue&type=style&index=0&id=7c3f615d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f615d",
  null
  
)

export default component.exports